import api from '../../apiConfig/apiConfig';
import { Post, Get, Put, Delete, Patch } from '../base/baseAjax';

let addMediafax = param => {
	return Post({
		url: api.mediafax.addMediafax,
		bodyParam: param,
	});
};
let editMediafax = (id, param) => {
	return Put({
		url: api.mediafax.editMediafax,
		bodyParam: param,
		PathParam: id,
	});
};

let getMediafaxDetail = param => {
	return Get({
		url: api.mediafax.getMediafaxDetail + param.id,
	});
};
let getMediafaxAccount = () => {
	return Get({
		url: api.mediafax.getMediafaxAccount,
	});
};
let getAuthUrl = param => {
	return Post({
		url: api.mediafax.getAuthUrl,
		bodyParam: param,
	});
};
let getPageList = param => {
	return Get({
		url: api.mediafax.getPageList,
		UrlParam: param,
		config: {
			timeout: 60000,
		},
	});
};
let bindPage = param => {
	return Post({
		url: api.mediafax.bindPage,
		bodyParam: param,
	});
};
let getMediafaxSubject = param => {
	return Get({
		url: api.mediafax.getMediafaxSubject,
		UrlParam: param,
	});
};
let removeMediafaxAccount = param => {
	return Delete({
		url: api.mediafax.removeMediafaxAccount,
		PathParam: param,
	});
};

let homePageContent = param => {
	return Get({
		url: api.mediafax.homePageContent,
		PathParam: {
			id: param,
		},
	});
};

let addWelcomeSpeech = param => {
	return Post({
		url: api.mediafax.addWelcomeSpeech,
		bodyParam: param,
	});
};

let updateWelcomeSpeech = param => {
	return Patch({
		url: api.mediafax.updateWelcomeSpeech,
		PathParam: { id: param.id },
		bodyParam: param,
	});
};

let updateStatus = param => {
	return Patch({
		url: api.mediafax.updateStatus,
		PathParam: {
			id: param.id,
		},
		bodyParam: param,
	});
};

// 检索主页列表
let getPageRetrieve = () => {
	return Get({
		url: api.mediafax.getPageRetrieve,
		config: {
			timeout: 120000,
		},
	});
};

// 平台绑定
let platformBind = param => {
	return Patch({
		url: api.mediafax.platformBind,
		PathParam: {
			id: param.id,
		},
		bodyParam: param,
	});
};

// 账号授权-返回授权链接
let oauthAccount = param => {
	return Get({
		url: api.mediafax.oauthAccount,
		PathParam: {
			id: param.id,
		},
		UrlParam: {
			businessCode: param.businessCode,
		},
	});
};

// 账号授权更新-返回主页信息
let oauthBind = param => {
	return Patch({
		url: api.mediafax.oauthBind,
		PathParam: {
			id: param.id,
		},
		UrlParam: {
			businessCode: param.businessCode,
		},
	});
};

export default {
	addMediafax,
	editMediafax,
	getMediafaxDetail,
	getAuthUrl,
	getPageList,
	bindPage,
	getMediafaxSubject,
	removeMediafaxAccount,
	getMediafaxAccount,
	homePageContent,
	addWelcomeSpeech,
	updateWelcomeSpeech,
	updateStatus,
	getPageRetrieve,
	platformBind,
	oauthAccount,
	oauthBind,
};
